export default function Hero() {
  const scrollToContact = () => {
    window.REACT_APP_NAVIGATE('/contact');
  };

  return (
    <section 
      className="relative min-h-screen flex items-center bg-cover bg-center"
      style={{
        backgroundImage: `linear-gradient(to right, rgba(255, 255, 255, 0.97) 0%, rgba(255, 255, 255, 0.97) 55%, rgba(255, 255, 255, 0.2) 100%), url('https://public.readdy.ai/ai/img_res/12f9d99c1507d9e308c38a38f0819548.jpg')`
      }}
    >
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-20 w-full">
        <div className="max-w-2xl">
          <h1 className="text-6xl md:text-7xl font-bold text-gray-900 mb-6 leading-tight opacity-0 animate-fade-in-up">
            The calm behind the <span className="text-teal-600">care</span>
          </h1>
          <p className="text-xl text-gray-700 mb-8 leading-relaxed opacity-0 animate-fade-in-up animation-delay-200">
            Everstead brings clean, modern operations to senior living communities through systems, workflows, and staff support that make care feel lighter and leadership feel stronger.
          </p>
          <div className="flex flex-col sm:flex-row gap-4 opacity-0 animate-fade-in-up animation-delay-400">
            <button 
              onClick={scrollToContact}
              className="bg-teal-600 text-white px-8 py-4 rounded-full text-lg font-semibold hover:bg-teal-700 hover:scale-105 transition-all whitespace-nowrap cursor-pointer shadow-lg"
            >
              Book Operations Assessment
            </button>
            <a 
              href="https://readdy.ai/api/search-image?query=Professional%20services%20guide%20document%20cover%20for%20senior%20living%20operations%20consultancy%20with%20clean%20modern%20minimalist%20design%2C%20teal%20and%20white%20color%20scheme%2C%20organized%20layout&width=800&height=1000&seq=services-guide-everstead&orientation=portrait"
              download="Everstead-Services-Guide.pdf"
              className="bg-white text-teal-600 px-8 py-4 rounded-full text-lg font-semibold border-2 border-teal-600 hover:bg-teal-50 hover:scale-105 transition-all whitespace-nowrap cursor-pointer text-center shadow-lg"
            >
              Download Services Guide
            </a>
          </div>
        </div>
      </div>
    </section>
  );
}
